import { useTranslation } from 'react-i18next';
import PrivacyEN from '../../Components/Privacy/Privacy.en';
import PrivacyFR from '../../Components/Privacy/Privacy_fr';

export function Privacy() {
  const { i18n } = useTranslation();
  
      return (
        <div>
          {
            i18n.language === "fr" ? <PrivacyFR/> : <PrivacyEN/>
          }
        </div>
    )
  }
  
  export default Privacy;